document.addEventListener('DOMContentLoaded', function () {

  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function showError(input, message) {
    let error = input.closest('.field').querySelector('.js-error');
    if (!error) {
      error = document.createElement('span');
      error.className = 'js-error form__message';
      input.closest('.field').appendChild(error);
    }
    error.textContent = message;
    input.setAttribute('aria-invalid', 'true');
  }

  function clearError(input) {
    const error = input.closest('.field').querySelector('.js-error');
    if (error) error.remove();
    input.removeAttribute('aria-invalid');
  }

  // ==========================================
  // LOGIN FORM VALIDATION
  // ==========================================
  const loginForm = document.querySelector('form[action="/account/login"]');
  if (loginForm) {
    const loginFields = {
      email: {
        input: loginForm.querySelector('#CustomerEmail'),
        validate: (v, input) => {
          // Check if browser autofill is holding the value hostage
          const isAutofilled = input && (input.matches(':-webkit-autofill') || input.matches(':autofill'));
          if (v.trim() === '' && !isAutofilled) return 'required';
          if (!isAutofilled && v.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'invalid';
          return 'valid';
        },
        message: { required: 'Email is required', invalid: 'Enter correct email' }
      }
    };

    const passwordInput = loginForm.querySelector('#CustomerPassword');
    if (passwordInput) {
      loginFields.password = {
        input: passwordInput,
        validate: (v, input) => {
          const isAutofilled = input && (input.matches(':-webkit-autofill') || input.matches(':autofill'));
          return (v.trim() === '' && !isAutofilled) ? 'required' : 'valid';
        },
        message: { required: 'Password is required' }
      };
    }

    function validateLoginField(key) {
      const field = loginFields[key];
      const result = field.validate(field.input.value, field.input); // Pass the input element

      if (result !== 'valid') {
        showError(field.input, field.message[result]);
        return false;
      }
      clearError(field.input);
      return true;
    }

    Object.keys(loginFields).forEach(key => {
      loginFields[key].input.addEventListener('blur', () => validateLoginField(key));
      loginFields[key].input.addEventListener('input', () => clearError(loginFields[key].input));
    });

    loginForm.addEventListener('submit', function (e) {
      let valid = true;
      let firstInvalid = null;

      Object.keys(loginFields).forEach(key => {
        if (!validateLoginField(key)) {
          valid = false;
          if (!firstInvalid) firstInvalid = loginFields[key].input;
        }
      });

      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        firstInvalid.focus();
        return false;
      }

      // UX FIX: Prevent impatience double-clicks while Shopify reCAPTCHA processes
      const submitBtn = loginForm.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.style.pointerEvents = 'none';
        submitBtn.style.opacity = '0.7';
        submitBtn.classList.add('loading');
      }
    });
  }

  // ==========================================
  // RECOVER FORM VALIDATION
  // ==========================================
  const recoverForm = document.querySelector('form[action="/account/recover"]');
  if (recoverForm) {
    const recoverFields = {
      email: {
        input: recoverForm.querySelector('#RecoverEmail'),
        validate: (v, input) => {
          const isAutofilled = input && (input.matches(':-webkit-autofill') || input.matches(':autofill'));
          if (v.trim() === '' && !isAutofilled) return 'required';
          if (!isAutofilled && v.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'invalid';
          return 'valid';
        },
        message: { required: 'Email is required', invalid: 'Enter correct email' }
      }
    };

    function validateRecoverField(key) {
      const field = recoverFields[key];
      const result = field.validate(field.input.value, field.input);

      if (result !== 'valid') {
        showError(field.input, field.message[result]);
        return false;
      }
      clearError(field.input);
      return true;
    }

    Object.keys(recoverFields).forEach(key => {
      recoverFields[key].input.addEventListener('blur', () => validateRecoverField(key));
      recoverFields[key].input.addEventListener('input', () => clearError(recoverFields[key].input));
    });

    recoverForm.addEventListener('submit', function (e) {
      let valid = true;
      let firstInvalid = null;

      Object.keys(recoverFields).forEach(key => {
        if (!validateRecoverField(key)) {
          valid = false;
          if (!firstInvalid) firstInvalid = recoverFields[key].input;
        }
      });

      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        firstInvalid.focus();
        return false;
      }

      const submitBtn = recoverForm.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.style.pointerEvents = 'none';
        submitBtn.style.opacity = '0.7';
      }
    });
  }
  setTimeout(() => {
    const loginEmail = document.querySelector('#CustomerEmail');
    if (loginEmail) {
      loginEmail.focus();
    }
  }, 100);
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".toggle-password").forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = this.previousElementSibling;
      const eye = this.querySelector(".icon-eye-off");
      const eyeOff = this.querySelector(".icon-eye");

      if (input.type === "password") {
        input.type = "text";
        eye.style.display = "none";
        eyeOff.style.display = "block";
      } else {
        input.type = "password";
        eye.style.display = "block";
        eyeOff.style.display = "none";
      }
    });
  });
});